var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLevelup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 44,
    viewBox: "0 0 111 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.459 3.07666H22.5407C12.0704 3.07666 3.58252 11.5481 3.58252 21.9981V22.0019C3.58252 32.4519 12.0704 40.9234 22.5407 40.9234H88.459C98.9294 40.9234 107.417 32.4519 107.417 22.0019V21.9981C107.417 11.5481 98.9294 3.07666 88.459 3.07666Z",
    fill: "url(#paint0_linear_11_1660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.459 27.2245H22.5407C14.4912 27.2245 7.63233 22.2096 4.88108 15.1487C4.05262 17.2754 3.58252 19.5791 3.58252 21.9981C3.58252 32.4472 12.0713 40.9195 22.5407 40.9195H88.4552C98.9246 40.9195 107.413 32.4472 107.413 21.9981C107.413 19.5791 106.943 17.2754 106.115 15.1487C103.364 22.2096 96.5047 27.2245 88.4552 27.2245H88.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4592 3.07665C98.9286 3.07665 107.417 11.549 107.417 21.9981C107.417 32.4472 98.9286 40.9195 88.4592 40.9195H22.5408C12.0714 40.9195 3.58264 32.4472 3.58264 21.9981C3.58264 11.549 12.0714 3.07665 22.5408 3.07665H88.4553M88.4592 0H22.5408C10.3876 0 0.5 9.86837 0.5 21.9981C0.5 34.1278 10.3876 43.9962 22.5408 43.9962H88.4553C100.609 43.9962 110.496 34.1278 110.496 21.9981C110.496 9.86837 100.612 0 88.4592 0Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3777 12.0604C13.3777 13.2103 12.4413 14.1449 11.2892 14.1449C10.137 14.1449 9.20068 13.2103 9.20068 12.0604C9.20068 10.9105 10.137 9.97601 11.2892 9.97601C12.4413 9.97601 13.3777 10.9105 13.3777 12.0604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1077 8.03775C17.1077 8.77614 16.5066 9.37609 15.7667 9.37609C15.0269 9.37609 14.4258 8.77614 14.4258 8.03775C14.4258 7.29935 15.0269 6.6994 15.7667 6.6994C16.5066 6.6994 17.1077 7.29935 17.1077 8.03775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7898 8.03775C96.7898 8.77614 96.1887 9.37609 95.4489 9.37609C94.709 9.37609 94.1079 8.77614 94.1079 8.03775C94.1079 7.29935 94.709 6.6994 95.4489 6.6994C96.1887 6.6994 96.7898 7.29935 96.7898 8.03775Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.1826 28.9859V15.2794H24.0396V23.7171H29.5999V28.9859H18.1826Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1343 16.2294H23.0916V24.6632H28.6519V28.036H19.1343V16.2255V16.2294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0311 29.209C32.2739 29.209 30.8213 28.6782 29.7115 27.636C28.5825 26.5669 28.0122 25.1747 28.0122 23.4864C28.0122 21.7981 28.5517 20.4367 29.6152 19.3367C30.6864 18.2253 32.0659 17.6638 33.7151 17.6638C35.5608 17.6638 37.0289 18.2753 38.0693 19.479C38.9979 20.5674 39.4681 21.9827 39.4681 23.6902C39.4681 24.021 39.4681 24.2594 39.4411 24.4555L39.3332 25.2824H38.5471L39.5721 26.0977L38.998 26.8399C37.7765 28.4167 36.108 29.2167 34.0349 29.2167L34.0311 29.209Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9604 23.4826V23.448C28.9604 22.0635 29.3997 20.9174 30.2937 19.9906C31.1915 19.0637 32.3398 18.6061 33.7077 18.6061C35.2799 18.6061 36.4782 19.0945 37.3414 20.0906C38.1197 21.002 38.5089 22.1981 38.5089 23.6826C38.5089 23.971 38.5089 24.1902 38.4896 24.3248H32.5594C32.8292 25.1517 33.4033 25.5555 34.3011 25.5555C34.9408 25.5555 35.5688 25.2324 36.1777 24.6094L38.2392 26.2439C37.2065 27.5745 35.8078 28.2514 34.0314 28.2514C32.5286 28.2514 31.2955 27.813 30.363 26.9361C29.4344 26.0593 28.9604 24.9132 28.9604 23.4787V23.4826ZM35.0101 22.6403C34.9253 21.7135 34.4861 21.2558 33.727 21.2558C33.0334 21.2558 32.6288 21.7135 32.5093 22.6403H35.0101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4567 29.0552L36.9561 17.8792H43.0789L43.8804 20.3636L44.6858 17.8792H50.7586L46.2579 29.0552H41.4567Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3623 18.8253H42.3851L43.8725 23.4479L45.3753 18.8253H49.348L45.6142 28.1052H42.0961L38.3623 18.8253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1224 29.209C52.3653 29.209 50.9126 28.6782 49.8028 27.636C48.6738 26.5707 48.1035 25.1747 48.1035 23.4864C48.1035 21.7981 48.643 20.4367 49.7065 19.3367C50.7777 18.2253 52.1572 17.6638 53.8064 17.6638C55.6521 17.6638 57.1164 18.2753 58.1606 19.479C59.0893 20.5674 59.5594 21.9827 59.5594 23.6902C59.5594 24.021 59.5594 24.2594 59.5324 24.4594L59.4206 25.2824H58.6346L59.6595 26.0938L59.0854 26.8361C57.8639 28.4129 56.1954 29.2128 54.1224 29.2128V29.209Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0513 23.4826V23.448C49.0513 22.0635 49.4905 20.9174 50.3845 19.9906C51.2823 19.0637 52.4306 18.6061 53.7985 18.6061C55.3707 18.6061 56.569 19.0945 57.4322 20.0906C58.2106 21.002 58.5997 22.1981 58.5997 23.6826C58.5997 23.971 58.5997 24.1902 58.5805 24.3248H52.6502C52.92 25.1517 53.4941 25.5555 54.3919 25.5555C55.0316 25.5555 55.6597 25.2324 56.2685 24.6094L58.33 26.2439C57.2973 27.5745 55.8986 28.2514 54.1222 28.2514C52.6194 28.2514 51.3864 27.813 50.4539 26.9361C49.5252 26.0593 49.0513 24.9132 49.0513 23.4787V23.4826ZM55.1009 22.6403C55.0162 21.7135 54.5769 21.2558 53.8178 21.2558C53.1242 21.2558 52.7196 21.7135 52.6002 22.6403H55.1009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2717 14.7756H58.5342V28.9898H64.2717V14.7756Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4863 15.7255H63.3242V28.0398H59.4863V15.7255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1092 29.2244C69.6856 29.2244 67.3467 26.9822 67.3467 22.7441V15.2833H73.2692V22.6942C73.2692 23.8364 73.7162 23.8364 74.1439 23.8364C74.6718 23.8364 75.0186 23.7633 75.0186 22.7788V15.2833H80.945V22.6595C80.945 26.9553 78.5829 29.2282 74.1131 29.2282L74.1092 29.2244Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2983 16.2294H72.3212V22.6903C72.3212 24.0902 72.93 24.7825 74.1476 24.7825C75.3653 24.7825 75.9741 24.1056 75.9741 22.775V16.2294H79.9969V22.6557C79.9969 26.4016 78.0356 28.2745 74.113 28.2745C70.1903 28.2745 68.2983 26.4362 68.2983 22.7403V16.2294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3018 28.9859V15.2794H86.5788C88.3898 15.2794 89.8656 15.6948 90.9677 16.5139C92.2007 17.4446 92.8211 18.7599 92.8211 20.429C92.8211 22.0981 92.1969 23.5095 90.9677 24.4671C89.8348 25.3401 88.3282 25.7823 86.494 25.7823H86.1588V28.9859H80.3018ZM86.2744 21.0674C87.0142 21.0674 87.0142 20.8982 87.0142 20.7174C87.0142 20.502 87.0142 20.3328 86.2898 20.3328H86.1588V21.0674H86.2744Z",
    fill: "#3F2806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2495 16.2294H86.5748C88.197 16.2294 89.4647 16.5832 90.3934 17.2754C91.376 18.0177 91.8653 19.0637 91.8653 20.429V20.4636C91.8653 21.8635 91.376 22.9442 90.378 23.721C89.4146 24.4633 88.1315 24.8363 86.49 24.8363H85.2068V28.0399H81.2495V16.2294ZM86.2704 22.0173C87.4032 22.0173 87.962 21.5789 87.962 20.7174V20.6828C87.962 19.8214 87.4032 19.3829 86.2896 19.3829H85.2068V22.0135H86.2704V22.0173Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1660",
    x1: 55.5018,
    y1: 40.9234,
    x2: 55.5018,
    y2: 3.07666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F29F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F1BA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1C40F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLevelup);
export default __webpack_public_path__ + "static/media/btn-levelup.8bd4e30e94909279d7252310d5278b60.svg";
export { ForwardRef as ReactComponent };